/**
 * Stellar blog, filtres actifs + recherche articles (grille + Shopify Search)
 */
(function () {
 'use strict';

 var DOS_CHAR_MS = 48;
 var DOS_START_DELAY = 280;

 function prefersReducedMotion() {
 return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 }

 function initDosTypewriters(root) {
 root.querySelectorAll('[data-dos-type]').forEach(function (el) {
 if (el.dataset.dosInit === 'true') return;
 el.dataset.dosInit = 'true';

 var text = el.getAttribute('data-dos-text') || '';
 var out = el.querySelector('[data-dos-out]');
 if (!out || !text) return;

 var timer = null;
 var idx = 0;
 var reduced = prefersReducedMotion();
 var autostart = el.hasAttribute('data-dos-autostart');
 var card = el.closest('[data-realisation-card]');

 function clearTimer() {
 if (timer) {
 clearTimeout(timer);
 timer = null;
 }
 }

 function reset() {
 clearTimer();
 idx = 0;
 out.textContent = '';
 el.classList.remove('is-typing', 'is-done');
 }

 function finish() {
 clearTimer();
 el.classList.remove('is-typing');
 el.classList.add('is-done');
 }

 function typeStep() {
 if (idx >= text.length) {
 finish();
 return;
 }
 out.textContent += text.charAt(idx);
 idx += 1;
 timer = setTimeout(typeStep, DOS_CHAR_MS);
 }

 function start() {
 if (reduced) {
 out.textContent = text;
 el.classList.add('is-done');
 return;
 }
 reset();
 el.classList.add('is-typing');
 timer = setTimeout(typeStep, DOS_START_DELAY);
 }

 if (autostart) {
 start();
 return;
 }

 if (card) {
 card.addEventListener('mouseenter', start);
 card.addEventListener('mouseleave', function () {
 if (!reduced) reset();
 });
 }
 });
 }

 document.querySelectorAll('[data-stellar-blog]').forEach(function (root) {
 initDosTypewriters(root);
 root.querySelectorAll('.stl-blog-filter').forEach(function (link) {
 link.addEventListener('click', function () {
 root.querySelectorAll('.stl-blog-filter').forEach(function (el) {
 el.classList.remove('is-active');
 el.removeAttribute('aria-current');
 });
 link.classList.add('is-active');
 link.setAttribute('aria-current', 'page');
 });
 });

 var searchInput = root.querySelector('[data-blog-search-input]');
 var grid = root.querySelector('[data-blog-grid]');
 if (!searchInput || !grid) return;

 var cards = function () {
 return grid.querySelectorAll('[data-stl-tx-card]');
 };

 var emptyMsg = grid.querySelector('[data-blog-search-empty]');
 if (!emptyMsg) {
 emptyMsg = document.createElement('p');
 emptyMsg.className = 'stl-blog-search-empty';
 emptyMsg.setAttribute('data-blog-search-empty', '');
 emptyMsg.hidden = true;
 emptyMsg.textContent =
 searchInput.getAttribute('data-empty-label') || 'Aucun article ne correspond à votre recherche.';
 grid.appendChild(emptyMsg);
 }

 function filterGrid() {
 var q = searchInput.value.trim().toLowerCase();
 var visible = 0;

 cards().forEach(function (card) {
 var hay = card.getAttribute('data-search-haystack') || '';
 var match = !q || hay.indexOf(q) !== -1;
 card.hidden = !match;
 if (match) visible += 1;
 });

 emptyMsg.hidden = !q || visible > 0;
 grid.classList.toggle('is-search-empty', q.length > 0 && visible === 0);
 }

 searchInput.addEventListener('input', filterGrid);
 searchInput.addEventListener('search', filterGrid);
 });

 document.querySelectorAll('[data-stellar-article]').forEach(function (root) {
 initDosTypewriters(root);
 });
})();
